module.exports = __webpack_public_path__ + "img/es_es.9fba2fa9.png";